import { render, staticRenderFns } from "./AppTeaser.vue?vue&type=template&id=2d4d79d9&scoped=true&"
import script from "./AppTeaser.vue?vue&type=script&lang=js&"
export * from "./AppTeaser.vue?vue&type=script&lang=js&"
import style0 from "./AppTeaser.vue?vue&type=style&index=0&id=2d4d79d9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4d79d9",
  null
  
)

export default component.exports